import keyMirror from 'keymirror';

export const McpConstants = keyMirror({
  GET_MCP_TOKENS_REQUEST: null,
  GET_MCP_TOKENS_SUCCESS: null,
  GET_MCP_TOKENS_FAILURE: null,

  CREATE_MCP_TOKEN_REQUEST: null,
  CREATE_MCP_TOKEN_SUCCESS: null,
  CREATE_MCP_TOKEN_FAILURE: null,

  REVOKE_MCP_TOKEN_REQUEST: null,
  REVOKE_MCP_TOKEN_SUCCESS: null,
  REVOKE_MCP_TOKEN_FAILURE: null,

  GET_MCP_SESSION_REQUESTS_REQUEST: null,
  GET_MCP_SESSION_REQUESTS_SUCCESS: null,
  GET_MCP_SESSION_REQUESTS_FAILURE: null,

  DECIDE_MCP_SESSION_REQUEST_REQUEST: null,
  DECIDE_MCP_SESSION_REQUEST_SUCCESS: null,
  DECIDE_MCP_SESSION_REQUEST_FAILURE: null,

  GET_MCP_SESSION_REQUEST: null,
  GET_MCP_SESSION_SUCCESS: null,
  GET_MCP_SESSION_FAILURE: null,

  START_MCP_SESSION_REQUEST: null,
  START_MCP_SESSION_SUCCESS: null,
  START_MCP_SESSION_FAILURE: null,

  DELETE_MCP_SESSION_REQUEST: null,
  DELETE_MCP_SESSION_SUCCESS: null,
  DELETE_MCP_SESSION_FAILURE: null,

  GET_MCP_CALL_LOG_REQUEST: null,
  GET_MCP_CALL_LOG_SUCCESS: null,
  GET_MCP_CALL_LOG_FAILURE: null,
});

export default McpConstants;
